import { endPoints, defaultAPICloudSetting } from "@/constants/apiSetting";
import StorageService from "@/service/StorageService";
import HttpClient from "axios";
import { defaultMizarAPISetting } from "@/constants/apiSetting";
import { store } from "@/store";
import StoreGetter from "@/constants/StoreGetter";

const ServerService = {
  getServerSysMsg() {
    let lang = "EN";
    const apiURL = `localization/${lang}/messages`;
    return HttpClient.post(apiURL, null, defaultAPICloudSetting);
  },
  getServerRouter(compCode, projCode) {
    const reqObj = {
      model: {
        CompCode: compCode,
        projCode: projCode
      }
    };
    return HttpClient.post(
      endPoints.server.getServerRouter,
      reqObj,
      defaultAPICloudSetting
    );
  },
  getServerRouterByCompCode(compCode) {
    const reqObj = {
      model: {
        CompCode: compCode
      }
    };
    return HttpClient.post(
      endPoints.server.getServerRouterByCompCode,
      reqObj,
      defaultAPICloudSetting
    );
  },
  checkIsReg(model) {
    const reqObj = {
      model: model
    };
    return HttpClient.post(
      endPoints.server.checkIsReg,
      reqObj,
      defaultAPICloudSetting
    );
  },

  regPhone(model, serverModel) {
    const reqObj = {
      model: model,
      serverModel: serverModel
    };
    return HttpClient.post(
      endPoints.server.regPhone,
      reqObj,
      defaultAPICloudSetting
    );
  },
  async getBaseURL() {
    const item = await StorageService.getItem(asyncDict.serverRouter);
    let baseURL = "";
    if (item) {
      const serverRouter = JSON.parse(item);
      baseURL = serverRouter.ServerIP;
    } else {
      throw new Error("Server not found, please contact technical support.");
    }
    return baseURL;
  },
  getMizarServerRouter() {
    const serverRouterURL = "api/authentication/getserver";
    const serverRouterObj = {
      compCode: store.getters[StoreGetter.serverRouter].CompCode,
      //compCode: "TEST"
    };
    //var serverRouterResponse = await axios.post(serverRouterURL, serverRouterObj, defaultMizarAPISetting);
    return HttpClient.post(serverRouterURL, serverRouterObj, defaultMizarAPISetting);
  },
  getMizarToken(Url){
    const serverRouterURL = "webapi/authentication/login";
    const APISetting = {
      baseURL: Url,
      timeout: 200000,
      headers: {
        "Content-Type": "application/json"
      }
    };
    const serverRouterObj = {
      compCode: store.getters[StoreGetter.serverRouter].CompCode,
      //compCode: "TEST",
      username: "sa",
      password: "Bexadmin"
    };
    return HttpClient.post(serverRouterURL, serverRouterObj, APISetting);
  }
};

export default ServerService;



// WEBPACK FOOTER //
// ./src/service/ServerService.js